import LockedFeature from 'components/generic/LockedFeature'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './blurredWtnHistoryChart.module.scss'
import useElement from 'hooks/use-element'
import cx from 'classnames'

const DEFAULT_LINES = 13

const getWhiteSpaceVals = (container: HTMLDivElement) => {
  const { width } = container.getBoundingClientRect()
  const gap = Math.floor((width * 0.4) / DEFAULT_LINES)
  const paddingSide = Math.floor(gap / 2)
  return {
    gap,
    paddingSide,
  }
}

const BlurredWtnHistoryChart = () => {
  const { t } = useTranslation('strProfile')
  const [container, containerRef] = useElement<HTMLDivElement>()
  const [lines] = useState<number[]>(() =>
    new Array(DEFAULT_LINES).fill(true).map(() => Math.floor(Math.random() * 100))
  )
  const [whiteSpaceVals, setWhiteSpaceVals] = useState({
    gap: 2,
    paddingSide: 1,
  })

  useEffect(() => {
    if (container) setValues()

    window.addEventListener('resize', setValues)

    function setValues() {
      if (container) {
        setWhiteSpaceVals(getWhiteSpaceVals(container))
      }
    }

    return () => {
      window.removeEventListener('resize', setValues)
    }
  }, [container])

  return (
    <>
      <LockedFeature info={{ ns: 'strMessageScreen', transKey: 'lockedFeature.blurredWtnHistory' }}>
        <div className={styles.blurredWtnHistory} aria-hidden>
          <div className={styles.filterBar}>
            <div className={cx(styles.filter, styles.commonSelectInput)}>
              someDate
              <span>-</span>
              otherDate
            </div>
            <div className={cx(styles.filter, styles.commonSelectInput)}>someFilter</div>
          </div>
          <div
            ref={containerRef}
            className={styles.linesContainer}
            style={{ gap: whiteSpaceVals.gap, paddingInline: whiteSpaceVals.paddingSide }}
          >
            {lines.map((lineHeight, i) => (
              <div key={i} className={styles.line} style={{ height: `${lineHeight}%` }} />
            ))}
          </div>
        </div>
      </LockedFeature>
    </>
  )
}

export default BlurredWtnHistoryChart
